var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.948 266.877L277.502 476.001C268.859 489.001 256.354 496 243.51 496C238.328 496 233.086 494.86 228.044 492.52C209.537 483.961 200.574 462.103 206.756 440.524L230.845 336.012H154.217C132.609 336.012 112.922 324.153 102.799 305.074C92.6748 285.996 93.9353 263.017 106.06 245.159L234.466 35.994C246.611 17.7553 266.338 11.3358 283.944 19.4752C302.451 28.0346 311.414 49.8929 305.232 71.4713L281.123 176.004L357.811 176.064C379.399 176.064 399.086 187.923 409.21 207.001C419.313 226.06 418.073 249.038 405.948 266.897V266.877Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.948 266.877L277.502 476.001C268.859 489.001 256.354 496 243.51 496C238.328 496 233.086 494.86 228.044 492.52C209.537 483.961 200.574 462.103 206.756 440.524L230.845 336.012H154.217C132.609 336.012 112.922 324.153 102.799 305.074C92.6748 285.996 93.9353 263.017 106.06 245.159L234.466 35.994C246.611 17.7553 266.338 11.3358 283.944 19.4752C302.451 28.0346 311.414 49.8929 305.232 71.4713L281.123 176.004L357.811 176.064C379.399 176.064 399.086 187.923 409.21 207.001C419.313 226.06 418.073 249.038 405.948 266.897V266.877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.4c117fa55391aba24a04726e1b2a6069.svg";
export { ForwardRef as ReactComponent };